import { getProductSupplier } from 'src/utils/firebase/firebase-short-cut';
import useSWR from 'swr';

const useProductSupplier = (productSupplierId?: string) => {
  const { data, isLoading } = useSWR(productSupplierId ? [productSupplierId, 'product-supplier'] : null, () =>
    productSupplierId ? getProductSupplier(productSupplierId) : null
  );
  return { productSupplier: data ?? null, isLoading };
};

export default useProductSupplier;
